import { createFileRoute, redirect } from '@tanstack/react-router';
import { LoadingScreen } from '@/features/layout/LoadingScreen';

/**
 * The "/" route exists primarily to handle two cases:
 *
 *  1. MSAL's redirectUri lands here after a successful login (redirectUri is
 *     always the app's origin, never /sign-in).  InnerApp's useEffect reads
 *     sessionStorage and calls router.history.replace(savedPath), which causes
 *     this beforeLoad to re-run with the restored path — at that point the
 *     isLoading=false + isAuthenticated=true branch kicks in and redirects.
 *
 *  2. Regular visit to "/" by a returning authenticated user — redirect to /chat.
 *
 * While MSAL is still processing its redirect (isLoading=true) the component
 * renders a loading screen; InnerApp's useEffect drives the next step.
 */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    // MSAL is still initialising — let the component render a loading screen.
    // InnerApp will call router.history.replace once auth state is settled.
    if (context.auth.isLoading) return;

    // Authenticated: route to the default destination.
    if (context.auth.isAuthenticated) {
      throw redirect({ to: '/chat', replace: true });
    }

    // Not authenticated: trigger _app's beforeLoad guard on /chat which will
    // save the intended path and redirect to /sign-in.
    throw redirect({ to: '/chat', replace: true });
  },
  component: () => <LoadingScreen message='Loading...' />,
});
